import React from 'react'
import PropTypes from 'prop-types'

const lineStyle = {
  fill: 'none',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  strokeMiterlimit: 10,
}

const MinusCircleIcon = ({ customClassName, width, height, fill, line, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Minus Circle"
    viewBox="0 0 50 50"
  >
    <title id="plus-circle-icon">Plus Circle</title>
    <g>
      <circle fill={fill} cx="25" cy="25" r="25" />
      <line stroke={line} style={lineStyle} x1="38" y1="25" x2="12" y2="25" />
    </g>
  </svg>)

MinusCircleIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  line: PropTypes.string,
  customClassName: PropTypes.string,
}

MinusCircleIcon.defaultProps = {
  width: 20,
  height: undefined,
  fill: 'white',
  line: 'blue',
  customClassName: '',
}

export default MinusCircleIcon



// WEBPACK FOOTER //
// ./src/components/icons/MinusCircle.js